import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-brand-bell",
  "use": "icon-brand-bell-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-brand-bell\"><path d=\"M12 3a2 2 0 00-2 2v.2A6.5 6.5 0 005.5 11.5V16l-1.5 1.5V19h16v-1.5L18.5 16v-4.5A6.5 6.5 0 0014 5.2V5a2 2 0 00-2-2zm0 16a2 2 0 002-2h-4a2 2 0 002 2z\" /><circle cx=\"18.2\" cy=\"5.2\" r=\"1.6\" opacity=\".9\" /><circle cx=\"20.6\" cy=\"3.4\" r=\"1\" opacity=\".55\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/brand-bell.svg
// module id = HcgA
// module chunks = 24